import { render, staticRenderFns } from "./ProductosPorCategoria.vue?vue&type=template&id=77248eb6&scoped=true"
import script from "./ProductosPorCategoria.vue?vue&type=script&lang=js"
export * from "./ProductosPorCategoria.vue?vue&type=script&lang=js"
import style0 from "./ProductosPorCategoria.vue?vue&type=style&index=0&id=77248eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77248eb6",
  null
  
)

export default component.exports